import { ATTACHEMENT_MAX_FILE_SIZE_MB } from "../shared/constants"

export const texts = {
    brand: "ArbTask",
    brandDescription: 'Built by a tree climber, for tree work.',

    loginPageHeadline: 'Everything you need for the tree job.',
    loginPageFeature1: 'Your jobs on an interactive map',
    loginPageFeature2: 'Professional quote generator',
    loginPageFeature3: 'Customer database',
    loginPageFeature4: 'Store job site photos',
    loginPageFeature5: 'Timesheets for your team',
    loginPageGetStarted: 'To get started, enter your email on the right, or sign in with Google or Facebook. New here? We\'ll create an account for you automatically.',
    loginPageMobileGetStarted: 'To get started, enter your email or sign in with Google or Facebook. If you\'re new, your account will be created automatically.',
    loginPageGetStartedEmailOnly: 'To get started, enter your email on the right. New here? We\'ll create an account for you automatically.',
    loginPageMobileGetStartedEmailOnly: 'To get started, enter your email. If you\'re new, your account will be created automatically.',

    brand_cgh: "CGH",
    brandDescription_cgh: 'Streamline Your Service Operations.',


    defaultError: '💥 Something fell. Please try again.',
    defaultSuccess: '🎉 Success!',

    poweredByArbTask: 'Powered by ArbTask',
    delete: 'Delete',
    edit: 'Edit',
    cancel: 'Cancel',
    save: 'Save',
    saving: 'Saving',
    saved: 'Saved',
    add: 'Add',
    view: 'View',
    confirm: 'Confirm',
    create: 'Create',
    send: 'Send',
    confirmation: 'Confirmation',
    thisActionCannotBeUndone: 'This action cannot be undone.',
    attendees: 'Attendees',
    name: 'Name',
    account: 'Account',
    logout: 'Logout',
    archive: 'Archive',
    unarchive: 'Unarchive',
    archived: 'Archived',
    preview: 'Preview',
    settings: 'Settings',
    userPreferences: 'User Preferences',
    orgSettings: 'Organization Settings',
    support: 'Support',
    supportDescription: 'Get help with using ArbTask',
    contactSupport: 'Contact Support',
    supportEmailDescription: 'Need help? Have a question? We\'re here to help you get the most out of ArbTask.',
    emailUs: 'Email us at:',
    responseTime: 'We typically respond within 24 hours during business days.',
    frequentlyAskedQuestions: 'Frequently Asked Questions',
    stillNeedHelp: 'Still need help?',
    stillNeedHelpDescription: 'If you can\'t find what you\'re looking for in our FAQ, don\'t hesitate to reach out directly.',
    supportSendEmail: 'Send us an email',

    // Support FAQs
    faqCreateDealQ: 'How do I create a new deal?',
    faqCreateDealA: 'To create a new deal, navigate to the pipeline view and click the \'New Deal\' button. Fill in the customer information, location, and any relevant details about the tree work needed.',
    faqAddTeamMembersQ: 'How can I add team members to my organization?',
    faqAddTeamMembersA: 'Go to Organization Settings and click on Team Management. You can invite new members by entering their email addresses. They will receive an invitation email to join your organization.',
    faqAttachFilesQ: 'How do I attach photos and documents to deals?',
    faqAttachFilesA: 'When viewing a deal, scroll down to the attachments section. You can drag and drop files or click to browse and select files. Perfect for before/after photos, permits, or inspection reports.',
    faqMapViewQ: 'How can I view tree service locations on a map?',
    faqMapViewA: 'Use the Map view from the main navigation to see all your deals plotted geographically. This helps with route planning and understanding your service area coverage.',
    faqSendEstimatesQ: 'How do I send estimates to customers?',
    faqSendEstimatesA: 'Create an offer within a deal, then use the share function to generate a link that you can send to your customer. They can view and approve estimates without needing an account.',

    noData: 'Nothing to show',
    contact: 'Contact',
    missing: 'Missing',
    organizations: 'Organizations',
    close: 'Close',
    thisFieldIsRequired: 'This field is required',
    user: 'User',

    // RUT tax subsidy
    rutTaxSubsidy: 'RUT Tax Subsidy',
    rutDescription: 'Apply 50% tax deduction for domestic services (RUT)',
    rutSubsidyAmount: 'RUT subsidy',
    toPay: 'To Pay',

    // Login
    emailSentTo: 'Email sent to',
    checkSpamFolder: 'If you don\'t see it, check your spam folder.',
    newVersionAvailable: 'New version available',
    reload: 'Reload',
    loginCodeInstructions: 'Click the link in the email, or enter the code from it below.',
    loginCode: 'Login code',
    verifyLoginCode: 'Verify code',
    invalidLoginCode: 'Invalid or expired code',
    emailAddress: 'Email Address',
    enterEmail: 'Enter Email',
    login: 'Login',
    acceptInvitation: 'Accept Invitation',
    signUp: 'Sign Up',
    signInWithGoogle: 'Sign in with Google',
    signInWithFacebook: 'Sign in with Facebook',
    orDivider: 'or',


    // Deals
    pipeline: 'Board',
    newDeal: 'New Deal',
    mapView: 'Map View',
    map: 'Map',
    navigate: 'Navigate',
    deals: 'Deals',
    noDeals: 'No deals found',
    deal: 'Deal',
    editPipeline: 'Edit Board',
    editPipelineDescription: 'Manage steps in your sales process',
    orphanedDeals: 'Orphaned Deals',
    orphanedDealsDescription: 'Deals from removed pipeline steps',
    addStep: 'Add Step',
    addStepDescription: 'Add a new step to your sales process',
    newStep: 'New Step',
    removeStep: 'Remove Step',
    lastUpdated: 'Last Updated',
    description: 'Description',
    address: 'Address',
    changeLayout: 'Change Layout',
    changeLayoutDescription: 'Change the layout of cards visible on the board',
    updatedAt: 'Last Updated',
    tags: 'Tags',
    riskAssessment: 'Risk Assessment',
    riskLevel: 'Risk Level',
    riskLow: 'Low',
    riskMedium: 'Medium',
    riskHigh: 'High',
    riskNotes: 'Notes (optional)',
    addRiskAssessment: 'Add Assessment',
    enableRiskAssessment: 'Risk Assessment',
    noRiskAssessments: 'No assessments recorded',
    setCompanyAddressToEnableDistanceCalculation: 'Set company address to enable distance calculation',

    // Actions
    actions: 'Actions',
    movedFromTo: 'Moved from {from} to {to}',
    createdIn: 'Created in {step}',
    day: 'day',
    days: 'days',
    hour: 'hour',
    hours: 'hours',
    minute: 'minute',
    minutes: 'minutes',
    second: 'second',
    seconds: 'seconds',
    beenHere: 'Been here {time}',
    hasNotBeenHere: 'Has not been here',

    // Settings
    accountSettings: 'Account Settings',
    accountSettingsDescription: 'Manage your account settings',
    language: 'Language',
    languageDescription: 'Select language for the app',
    logo: 'Logo',
    changeLogo: 'Change Logo',
    uploadLogo: 'Upload Logo',

    // Organization Settings
    organizationSettings: 'Organization Settings',
    organizationSettingsDescription: 'Manage your organization settings',
    headquarterDescription: 'Set your company\'s address',
    organizationNameDescription: 'Set your company\'s name visible',
    organizationLogoDescription: 'Upload your company\'s logo',
    organizationEmailDescription: 'Company email is used for notifications',
    organizationWebsiteDescription: 'Company website is used for links in offers',
    organizationNameRequired: 'Organization name is required. Please set it and save the form.',
    currency: 'Currency',
    currencyDescription: 'Currency used in offers and pricing',
    paymentInstructions: 'Payment Instructions',
    paymentInstructionsDescription: 'Shown on invoices so customers know how to pay (e.g. bank account, Swish, or reference number).',

    // Organization Tabs & Features
    details: 'Details',
    features: 'Features',
    enableHoursTracking: 'Enable Hours Tracking',

    // Danger Zone
    dangerZone: 'Danger Zone',
    createNewOrganization: 'Create New Organization',
    createNewOrganizationDescription: 'Set up a separate new organization. You will be switched into it right away.',
    organizationCreated: 'Organization created',
    deleteOrganization: 'Delete Organization',
    deleteOrganizationDescription: 'Permanently delete this organization, including all deals, customers, articles, equipment, and time records. This cannot be undone.',
    deleteOrganizationWarning: 'This will permanently delete this organization and all of its deals, customers, articles, equipment, and time records.',
    deleteOrganizationOwnerOnly: 'Only the organization owner can delete this organization.',
    organizationDeleted: 'Organization deleted',
    typeNameToConfirm: 'Type the name below to confirm:',
    transferOwnership: 'Transfer Ownership',
    transferOwnershipDescription: 'Make another team member the owner of this organization. You will become a member.',
    transferOwnershipOwnerOnly: 'Only the organization owner can transfer ownership.',
    transferOwnershipModalTitle: 'Transfer Ownership',
    transferOwnershipSelectMember: 'Select the member who will become the new owner',
    transferOwnershipNoEligibleMembers: 'Invite a team member before transferring ownership.',
    transferOwnershipWarning: 'You are about to make {email} the owner of this organization. You will become a member and lose owner-only access, such as billing and deleting the organization.',
    transferOwnershipConfirmEmail: 'Type the new owner\'s email below to confirm:',
    ownershipTransferred: 'Ownership transferred',

    // Articles
    articles: 'Articles',
    article: 'Article',
    newArticle: 'New Article',
    editArticle: 'Edit Article',
    articlesDescription: 'Articles are items or services that can be added to offers and invoices.',
    price: 'Price',
    priceWithVat: 'Price with VAT',
    priceWithoutVat: 'Price without VAT',
    priceWithoutVatPerHour: 'Price per hour without VAT',
    vat: 'VAT',
    searchArticle: 'Search for an article',
    createNewArticle: 'Create new article',
    distanceBasedArticle: 'Distance Based Article',
    distanceBasedDescription: 'This article will be automatically added to offers with a quantity equal to the distance in kilometers',
    isActivityArticle: 'Loggable Activity',
    isActivityArticleDescription: 'This article represents an activity that can be logged against in timesheets, priced per hour.',

    // Equipment
    equipment: 'Equipment',
    equipmentDescription: 'Track tools and equipment owned by your organization.',
    newEquipment: 'New Equipment',
    editEquipment: 'Edit Equipment',
    equipmentCategory: 'Category',
    equipmentMake: 'Make',
    equipmentModel: 'Model',
    equipmentSerialNumber: 'Serial Number',
    equipmentPurchaseDate: 'Purchase Date',
    equipmentPurchasePrice: 'Purchase Price',
    equipmentCurrentValue: 'Current Value',
    equipmentNotes: 'Notes',
    equipmentTotalPurchaseValue: 'Total Purchase Value',
    equipmentTotalCurrentValue: 'Total Current Value',
    equipmentCategoryChainsaw: 'Chainsaw',
    equipmentCategoryClimbingGear: 'Climbing Gear',
    equipmentCategoryTruck: 'Truck',
    equipmentCategoryChipper: 'Chipper',
    equipmentCategoryRigging: 'Rigging',
    equipmentCategoryHandTools: 'Hand Tools',
    equipmentCategoryOther: 'Other',

    // Timesheets
    timesheets: 'Timesheets',
    monday: 'Mon',
    tuesday: 'Tue',
    wednesday: 'Wed',
    thursday: 'Thu',
    friday: 'Fri',
    saturday: 'Sat',
    sunday: 'Sun',
    perDay: 'Per day',
    perWeek: 'Per week',
    week: 'Week',
    weekShort: 'w',
    totalHours: 'Total Hours',
    today: 'Today',
    yesterday: 'Yesterday',
    newTimesheetEntry: 'New Timesheet Entry',
    trackedTime: 'Tracked Time',
    addTime: 'Add Time',
    startWorking: 'Start working',
    stopWorking: 'Stop working',
    workingSince: 'Working since',
    start: 'Start',
    end: 'End',
    totalTimeHoursMinutes: 'Total time (hours : minutes)',
    notes: 'Notes',
    last7Days: 'Last 7 days',
    last30Days: 'Last 30 days',
    thisMonth: 'This month',
    lastMonth: 'Last month',
    customDates: 'Custom dates',
    startDate: 'Start Date',
    endDate: 'End Date',
    viewTimeline: 'View Timeline',
    required: 'Required',
    seeDealTimeLine: 'See Deal TimeLine',
    timeline: 'Deal timeline',
    timeRecords: 'Time Records',
    endDateAfterStartDate: 'End date should be after start date',
    hoursTracked: 'Hours tracked',
    dealDetails: 'Deal Details',
    deleteTimeRecord: 'Are you sure you want to delete this time record?',
    exportCsv: 'Export CSV',

    // Invoices
    invoices: 'Invoices',
    invoice: 'Invoice',
    createInvoice: 'Create Invoice',
    partialInvoice: 'Partial invoice',
    invoiceCreated: 'Invoice created',
    invoiceStatusDraft: 'Draft',
    invoiceStatusSent: 'Sent',
    invoiceStatusPaid: 'Paid',
    invoiceStatusCancelled: 'Cancelled',
    period: 'Period',
    sendInvoice: 'Send Invoice',
    sendInvoiceDescription: 'Send an invoice to a customer as a read-only link.',
    shareInvoiceMailto: "Dear {customerName},\n\nYou can view the invoice here:\n{link}\n\nBest regards,\n{organizationName}",
    shareInvoiceMailtoSubject: "New Invoice from {organizationName}",
    shareInvoiceSms: "Hi {customerName}, you can view the invoice from {organizationName} here: {link}",

    // Activities
    activity: 'Activity',
    splitHoursByActivity: 'Split hours by activity',
    fillRemaining: 'Fill remaining',
    assignedHours: 'Assigned',
    remainingHours: 'Remaining',
    activitySplitMismatch: 'The hours assigned to activities must add up to the total time.',
    groupBy: 'Group by',
    unassignedActivity: 'No activity',


    // Search
    search: 'Search',
    noResults: 'No results found',

    // Offers
    offer: 'Offer',
    offers: 'Offers',
    offersDescription: 'Manage your offers',
    comingSoon: 'Coming Soon',
    editDeal: 'Edit Deal',
    newOffer: 'New Offer',
    offerCreated: 'Offer created successfully',
    acceptedOffer: 'Accepted Offer',
    latestOffer: 'Latest Offer',
    manageOffers: 'Manage Offers',
    pending: 'Pending',
    saveAsTemplate: 'Save as Template',
    offerOpenedByCustomer: 'Offer opened by customer',
    offerAccepted: 'Offer accepted by customer',
    customerLeftComment: 'Customer left a comment',
    acceptOffer: 'Accept Offer',
    comment: 'Comment',
    noLocationSet: 'No location set',
    useCurrentLocation: 'Use current location',
    gettingLocation: 'Getting location...',
    pickOnMap: 'Pick on map',
    useThisLocation: 'Use this location?',
    locationPermissionDenied: 'Location permission denied',
    locationNotSupported: 'Location not supported by your browser',
    locationError: 'Failed to get your location',
    noOffer: 'No offer',

    // Attachements
    attachments: 'Attachments',
    addAttachment: 'Add Attachment',
    takePhoto: 'Take Photo',
    fileSizeTooLarge: `File size is too large ({size} MB). Max ${ATTACHEMENT_MAX_FILE_SIZE_MB} MB allowed.`,
    deleteAttachement: 'Delete Attachment',
    dropFileHere: 'Drop file here',
    noAttachments: 'No attachments available',
    photos: 'Photos',
    dragImagesHere: 'Drag images here to upload',
    browseFiles: 'Browse Files',
    download: 'Download',

    // Customers
    customer: 'Customer',
    customers: 'Customers',
    person: 'Person',
    company: 'Company',
    firstName: 'First Name',
    lastName: 'Last Name',
    phone: 'Phone',
    email: 'Email',
    website: 'Website',
    personalNumber: 'Personal Number',
    personalNumberShort: 'PN', // Personal Number abbreviation
    organizationNumber: 'Organization Number',
    newCustomer: 'New Customer',
    editCustomer: 'Edit Customer',
    note: 'Note',
    searchCustomer: 'Search Customer',
    pressEnterToCreateNewCustomer: 'Press enter to create <b>new customer</b>',
    changeCustomer: 'Change Customer',

    // Filters
    filters: 'Filters',
    clear: 'Clear',
    step: 'Step',

    // Due Date
    dueDate: 'Due Date',
    addDueDate: 'Add due date',

    // Team
    team: 'Team',
    teamDescription: 'Manage your organization\'s team members',
    addMember: 'Add Member',
    inviteMember: 'Invite a team member',
    enterEmails: 'Enter emails separated by commas',
    invalidEmails: 'Please enter valid email addresses.',
    invitationsCreated: 'Member invitations created',
    role: 'Role',
    status: 'Status',
    admin: 'Admin',
    manager: 'Manager',
    worker: 'Worker',
    memberDescription: 'Can see all jobs and manage them',
    workerDescription: 'Can only see jobs assigned to them',
    sendingInvitation: 'Sending invitation',
    invitationSent: 'Invitation sent',
    accepted: 'Accepted',
    viewed: 'Viewed',
    copyInvitationLink: 'Copy invitation link',
    invitationLinkCopied: 'Invitation link copied to clipboard',
    changeRole: 'Change role',
    changeRoleModalTitle: 'Change member role',
    changeRoleDelayWarning: 'It can take up to an hour for the new role to take effect, or until the member logs out and back in.',
    roleUpdated: 'Role updated',
    paused: 'Paused',
    pauseMember: 'Pause member',
    reactivateMember: 'Reactivate member',
    memberPaused: 'Member paused',
    memberReactivated: 'Member reactivated',

    // Share
    share: 'Share',
    shareDeal: 'Share a Deal',
    shareDescription: 'Share a deal with external user',
    linkCoppied: 'Link copied to clipboard',
    readonly: 'Read only',

    // Not found
    notFound: '404 - Not Found',
    notFoundDescription: 'These are not the trees you are looking for.',

    // Background Color
    backgroundColor: "Background Color",
    chooseColor: "Choose color",

    // Block Types
    textBlock: "Text",
    imageBlock: "Image",
    headingBlock: "Heading",
    lineBlock: "Line",
    organizationCustomerBlock: "Organization & Customer",

    // Organization/Customer Block
    organization: "Organization",
    seller: "Seller",
    editOrganization: "Edit Organization",
    noCustomer: "No customer selected",
    noName: "Unnamed",
    addRow: "Add Row",

    // Line items table
    deleteRow: "Delete Row",
    quantity: "Quantity",
    total: "Total",
    excludingVat: "Excluding VAT",
    moveUp: "Move Up",
    moveDown: "Move Down",
    sendOffer: "Send Offer",
    sendOfferDescription: "Send an offer to a customer. You will be notified when the customer opens the offer.",
    shareOfferMailto: "Dear {customerName},\n\nYou can view the offer here:\n{link}\n\nBest regards,\n{organizationName}",
    shareOfferMailtoSubject: "New Offer from {organizationName}",
    shareOfferSms: "Hi {customerName}, you can view the offer from {organizationName} here: {link}",
    sendEmail: "Send Email",
    sendSMS: "Send SMS",
    addDiscount: "Add Discount",
    discount: "Discount",

    // Tree service texts
    treeServiceDescription: "We take pride in delivering high-quality, tailored tree care services. With our experienced staff and professional approach, we ensure your trees remain healthy, safe, and beautiful all year round. We understand the importance of careful planning and meticulous execution for each project.",
    treeServiceThankYou: "Thank you for considering us for your tree care needs.",

    // Integrations
    integrations: 'Integrations',
    integrationsDescription: 'Connect your organization with external services to enhance functionality',
    customerForm: 'Customer Form',
    customerFormDescription: 'Use this form to let customers create deals directly in your organization to avoid manual data entry.',
    customerFormHint: 'Use the link to replace contact forms on your website or social media.',
    customerFormLanguage: 'Form language',
    customerFormLanguageDescription: 'The language customers see when they open this form.',
    customerFormIntroLabel: 'Intro heading',
    customerFormIntroDescription: 'Shown at the top of the form. Leave blank to use the default text.',
    customerFormThankYouLabel: 'Thank you message',
    customerFormThankYouDescription: 'Shown to customers after they submit the form. Leave blank to use the default text.',
    accounting: 'Accounting',
    fortnoxConnected: 'Fortnox is connected.',
    fortnoxDescription: 'Connect your Fortnox account to sync customers and articles.',
    connectFortnox: 'Connect Fortnox',
    failedToConnectFortnox: 'Failed to connect Fortnox',
    failedToInitiateFortnoxConnection: 'Failed to initiate Fortnox connection',
    syncCustomers: 'Sync customers',
    failedToSyncCustomers: 'Failed to sync customers',
    syncCustomersResult: 'Sync complete: {imported} imported, {linked} linked, {pushed} pushed to Fortnox.',
    tellUseAboutYourProject: "Tell us about your project",

    // Members
    members: 'Members',
    allMembers: "All members",
    noMembersAssigned: 'No members assigned',

    // Comments
    comments: 'Comments',
    noComments: 'No comments yet',
    writeComment: 'Write a comment...',
    addComment: 'Add Comment',

    // Avatar
    changeAvatar: 'Change avatar',
    avatarLinkedToGravatar: 'This avatar is linked to {email} via Gravatar.',
    avatarUpdateTime: 'It might take a few minutes for the new avatar to appear here after changing it on Gravatar.',
    // Billing
    billing: 'Billing',
    billingDescription: 'Manage your subscription and see available plans.',
    plan: 'Plan',
    currentPlan: 'Current Plan',
    availablePlans: 'Choose the Plan That Fits Your Workload',
    dealsPerMonth: 'Deals per month',
    upgrade: 'Upgrade',
    free: 'Free',
    base: 'Base',
    selectPlan: 'Select Plan',
    current: 'Current',
    // Billing page copy
    billingHeading: 'Simple, Fair Pricing That Grows With Your Work',
    billingIntro1: 'Pay only for the jobs you\'re actively managing - not the number of users on your team.',
    billingIntro2: 'Invite your whole crew, manage unlimited clients, and scale your plan as your workload grows.',
    billingFeature1: 'Unlimited team members',
    billingFeature2: 'Only pay for active jobs',
    billingFeature3: 'Upgrade or downgrade anytime',
    billingWhyTitle: 'Why ArbTask Pricing Works for Tree Care Businesses',
    billingWhyPara1: 'Tree care work is seasonal. Some months are packed, others slow down.',
    billingWhyPara2: 'ArbTask pricing is designed so you only pay for the work you\'re actually managing.',
    billingWhyBullet1: 'Fair for seasonal businesses - pricing adapts to your workload',
    billingWhyBullet2: 'Unlimited team members - add your whole crew without extra fees',
    billingWhyBullet3: 'Archive finished jobs anytime - free up space instantly',
    billingWhyBullet4: 'Scale up or down easily - change plans whenever needed',
    billingFooter1: 'You can archive finished jobs anytime to free up active slots.',
    billingFooter2: 'No contracts. No per-user fees.',
    trialActive: 'Trial active',
    trialActiveUntil: 'unlimited jobs until',
    unlimited: 'Unl',
    activeDeals: 'active deals',

    billedMonthly: 'Billed monthly',
    billedAnnually: 'Billed annually',
    perMonth: '/month',
    perYear: '/year',
    dealLimitReached: 'You have reached the active deals limit for your current plan. Please archive finished jobs or upgrade your plan to add more active deals.',
    dealLimitReachedNative: 'You have reached the active deals limit for your current plan. Archive finished jobs to add more active deals.',

    usageSectionHeader: 'Your Current Usage',
    usageSectionDescription: 'This shows how many active deals you are currently using out of your plan limit. Archive finished jobs to free up slots.',

    // Plan cards
    planTagLine0: 'Best for small crews getting started',
    planTagLine1: 'Best for small growing teams',
    planTagLine2: 'Best for established tree care businesses',
    planTagLine3: 'Best for large operations',
    planTagLineUnder0: 'Best for small crews getting started',
    planTagLineUnder1: 'Manage many projects without hitting limits.',
    planTagLineUnder2: 'Designed for companies managing many crews and active projects.',
    planTagLineUnder3: 'Run your entire operation without limits.',
    planBenefit00: 'Unlimited users',
    planBenefit01: 'Client tracking',
    planBenefit10: 'Everything in Free',
    planBenefit11: 'Manage up to 30 active jobs',
    planBenefit20: 'Everything in Starter',
    planBenefit21: 'Manage up to 100 active jobs',
    planBenefit30: 'Everything in Growth',
    planBenefit31: 'Unlimited active jobs',
}
